module.exports = __webpack_public_path__ + "img/radio-bandeirantes-2022.13a56fe3.png";